export default "__VITE_ASSET__bc7776b7__"